import React, { useEffect, useState, useRef } from 'react';
import './EventosCarousel.css';

const images = [
  '/images/evento b2b/IMG_9969.JPG',
  '/images/evento b2b/IMG_9891.JPG',
  '/images/evento b2b/IMG_0076.JPG',
  '/images/evento b2b/IMG_9971.JPG',
  '/images/evento b2b/grupal.JPG',
];

function shuffleArray(array) {
  const arr = array.slice();
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      { threshold: 0.3 }
    );
    const currentRef = ref.current;
    if (currentRef) observer.observe(currentRef);
    return () => { if (currentRef) observer.unobserve(currentRef); };
  }, [ref]);
  return isIntersecting;
}

function Counter({ to }) {
  const [count, setCount] = useState(1);
  const ref = useRef();
  const visible = useOnScreen(ref);
  useEffect(() => {
    if (!visible) return;
    let start = 1;
    let end = to;
    let duration = 1200;
    let startTime = null;
    function animate(ts) {
      if (!startTime) startTime = ts;
      const progress = Math.min((ts - startTime) / duration, 1);
      setCount(Math.floor(progress * (end - start) + start));
      if (progress < 1) requestAnimationFrame(animate);
      else setCount(end);
    }
    requestAnimationFrame(animate);
  }, [visible, to]);
  return <span ref={ref} className="contador-eventos">+{count.toLocaleString()}</span>;
}

const frasesSlider = [
  'Conecta, Inspírate y Crece',
  'Vive Experiencias Únicas',
  'Conoce gente increíble',
  'Haz Networking de Alto Nivel'
];

export default function EventosCarousel() {
  const [order, setOrder] = useState(() => shuffleArray(images));
  const [active, setActive] = useState(0);
  const intervalRef = useRef();
  const dragStartX = useRef(null);
  const dragging = useRef(false);
  const [modalImg, setModalImg] = useState(null);
  const [zoom, setZoom] = useState({ active: false, x: 0.5, y: 0.5, offsetX: 0, offsetY: 0 });
  const dragZoom = useRef({ dragging: false, startX: 0, startY: 0, lastOffsetX: 0, lastOffsetY: 0 });
  const [fraseIndex, setFraseIndex] = useState(0);
  const [fraseAnim, setFraseAnim] = useState('slide-in');
  const fraseTimeout = useRef();

  useEffect(() => {
    setOrder(shuffleArray(images));
    setActive(0);
  }, []);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setActive(a => (a + 1) % order.length);
    }, 2500);
    return () => clearInterval(intervalRef.current);
  }, [order]);

  useEffect(() => {
    setFraseAnim('slide-in');
    fraseTimeout.current = setTimeout(() => {
      setFraseAnim('slide-out');
      setTimeout(() => {
        setFraseIndex(i => (i + 1) % frasesSlider.length);
        setFraseAnim('slide-in');
      }, 500);
    }, 2000);
    return () => clearTimeout(fraseTimeout.current);
  }, [fraseIndex]);

  // Drag handlers
  function handleMouseDown(e) {
    dragging.current = true;
    dragStartX.current = e.clientX;
    clearInterval(intervalRef.current);
  }
  function handleMouseUp(e) {
    if (!dragging.current) return;
    const delta = e.clientX - dragStartX.current;
    if (delta > 50) {
      setActive(a => (a - 1 + order.length) % order.length);
    } else if (delta < -50) {
      setActive(a => (a + 1) % order.length);
    }
    dragging.current = false;
    intervalRef.current = setInterval(() => {
      setActive(a => (a + 1) % order.length);
    }, 2500);
  }
  function handleMouseLeave() {
    dragging.current = false;
  }

  // Touch handlers for mobile
  function handleTouchStart(e) {
    dragging.current = true;
    dragStartX.current = e.touches[0].clientX;
    clearInterval(intervalRef.current);
  }
  function handleTouchEnd(e) {
    if (!dragging.current) return;
    const delta = e.changedTouches[0].clientX - dragStartX.current;
    if (delta > 50) {
      setActive(a => (a - 1 + order.length) % order.length);
    } else if (delta < -50) {
      setActive(a => (a + 1) % order.length);
    }
    dragging.current = false;
    intervalRef.current = setInterval(() => {
      setActive(a => (a + 1) % order.length);
    }, 2500);
  }
  function handleTouchCancel() {
    dragging.current = false;
  }

  function handleDoubleClick(img) {
    setModalImg(img);
    setZoom({ active: false, x: 0.5, y: 0.5 });
  }

  // Touch handlers for opening modal
  const touchStartTime = useRef(0);
  const touchStartX = useRef(0);
  const touchStartY = useRef(0);

  function handleImgTouchStart(e) {
    touchStartTime.current = Date.now();
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  }

  function handleImgTouchEnd(e, img) {
    const touchEndTime = Date.now();
    const touchDuration = touchEndTime - touchStartTime.current;
    const touchEndX = e.changedTouches[0].clientX;
    const touchEndY = e.changedTouches[0].clientY;
    const touchDistance = Math.sqrt(
      Math.pow(touchEndX - touchStartX.current, 2) + 
      Math.pow(touchEndY - touchStartY.current, 2)
    );

    // Si es un toque largo (más de 500ms) y no se movió mucho, abrir modal
    if (touchDuration > 500 && touchDistance < 10) {
      setModalImg(img);
      setZoom({ active: false, x: 0.5, y: 0.5 });
    }
  }
  function closeModal() {
    setModalImg(null);
    setZoom({ active: false, x: 0.5, y: 0.5 });
  }
  function handleModalImgClick(e) {
    if (!zoom.active) {
      const rect = e.target.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      setZoom({ active: true, x, y, offsetX: 0, offsetY: 0 });
    }
    e.stopPropagation();
  }
  function handleModalImgDoubleClick(e) {
    if (zoom.active) {
      setZoom({ active: false, x: 0.5, y: 0.5, offsetX: 0, offsetY: 0 });
    }
    e.stopPropagation();
  }
  function handleModalImgMouseDown(e) {
    if (!zoom.active) return;
    dragZoom.current.dragging = true;
    dragZoom.current.startX = e.clientX;
    dragZoom.current.startY = e.clientY;
    dragZoom.current.lastOffsetX = zoom.offsetX;
    dragZoom.current.lastOffsetY = zoom.offsetY;
    e.preventDefault();
  }
  function handleModalImgMouseMove(e) {
    if (!zoom.active || !dragZoom.current.dragging) return;
    const dx = e.clientX - dragZoom.current.startX;
    const dy = e.clientY - dragZoom.current.startY;
    setZoom(z => ({ ...z, offsetX: dragZoom.current.lastOffsetX + dx, offsetY: dragZoom.current.lastOffsetY + dy }));
  }
  function handleModalImgMouseUp() {
    dragZoom.current.dragging = false;
  }

  // Touch handlers for modal zoom
  function handleModalImgTouchStart(e) {
    if (!zoom.active) return;
    dragZoom.current.dragging = true;
    dragZoom.current.startX = e.touches[0].clientX;
    dragZoom.current.startY = e.touches[0].clientY;
    dragZoom.current.lastOffsetX = zoom.offsetX;
    dragZoom.current.lastOffsetY = zoom.offsetY;
    e.preventDefault();
  }
  function handleModalImgTouchMove(e) {
    if (!zoom.active || !dragZoom.current.dragging) return;
    const dx = e.touches[0].clientX - dragZoom.current.startX;
    const dy = e.touches[0].clientY - dragZoom.current.startY;
    setZoom(z => ({ ...z, offsetX: dragZoom.current.lastOffsetX + dx, offsetY: dragZoom.current.lastOffsetY + dy }));
  }
  function handleModalImgTouchEnd() {
    dragZoom.current.dragging = false;
  }

  return (
    <section className="eventos-carousel-section">
      <h2 className="eventos-titulo">
        <Counter to={35} /> EVENTOS AL AÑO
      </h2>
      <p className={`eventos-subtitulo eventos-slider-frase ${fraseAnim}`}>{frasesSlider[fraseIndex]}</p>
      <div
        className="custom-coverflow"
        style={{ cursor: 'grab' }}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        onTouchCancel={handleTouchCancel}
      >
        {order.map((img, i) => {
          let className = 'coverflow-img';
          if (i === active) className += ' active';
          else if (i === (active - 1 + order.length) % order.length) className += ' left';
          else if (i === (active + 1) % order.length) className += ' right';
          else className += ' hidden';
          return (
            <img
              key={i}
              src={img}
              alt={`Evento ${i + 1}`}
              className={className}
              draggable="false"
              onDoubleClick={() => handleDoubleClick(img)}
              onTouchStart={handleImgTouchStart}
              onTouchEnd={(e) => handleImgTouchEnd(e, img)}
            />
          );
        })}
      </div>
      {modalImg && (
        <div className="eventos-modal-bg" onClick={closeModal}>
          <div className="eventos-modal-img-container">
            <img
              src={modalImg}
              alt="Evento grande"
              className={`eventos-modal-img${zoom.active ? ' zoomed' : ''}`}
              style={zoom.active ? {
                transform: `scale(2.1) translate(${-((zoom.x - 0.5) * 100) + (zoom.offsetX / 3)}%, ${-((zoom.y - 0.5) * 100) + (zoom.offsetY / 3)}%)`,
                cursor: dragZoom.current.dragging ? 'grabbing' : 'grab',
                transition: dragZoom.current.dragging ? 'none' : 'transform 0.4s cubic-bezier(.77,0,.18,1)'
              } : {
                transform: 'scale(1) translate(0,0)',
                cursor: 'zoom-in',
                transition: 'transform 0.4s cubic-bezier(.77,0,.18,1)'
              }}
              onClick={handleModalImgClick}
              onDoubleClick={handleModalImgDoubleClick}
              onMouseDown={handleModalImgMouseDown}
              onMouseMove={handleModalImgMouseMove}
              onMouseUp={handleModalImgMouseUp}
              onMouseLeave={handleModalImgMouseUp}
              onTouchStart={handleModalImgTouchStart}
              onTouchMove={handleModalImgTouchMove}
              onTouchEnd={handleModalImgTouchEnd}
            />
          </div>
        </div>
      )}
    </section>
  );
} 